import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState } from "react";
import Pageheader from "../common/Pageheader";
import { useTheme } from "@emotion/react";
import {
  Box,
  Button,
  Card,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography
} from "@mui/material";
import { useSelector } from "react-redux";
import { FETCH_MY_JOBPOSTING } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import moment from "moment";
import { BIGrey } from "../../assets/helpers";
import InfiniteScroll from "react-infinite-scroll-component";
import ViewJobPosting from "./ViewJobPosting";
import Loader from "../../common/Loader";
import JobPlaceHolder from "../../assets/images/job_placeholder.png";
import Emptydata from "../common/Emptydata";
import { useNavigate } from "react-router-dom";
import { Add } from "@mui/icons-material";
import PostAJobModal from "./PostAJobModal";
import SendIcon from "@mui/icons-material/Send";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { English } from "../../constant/EnglishFallback";

export default function MyJobPosting() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const loginData = useSelector((state) => state.main?.loginData);
  const [myJobPost, setMyJobPost] = useState([]);
  const [showJobDetailsModal, setShowJobDetailsModal] = useState(false);
  const [selectedJobDetails, setSelectedJobDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(false);
  const [isNextDataCalled, setIsNextDataCalled] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showPostAJobModal, setShowPostAJobModal] = useState(false);

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.JobPostings || {};

  const {
    TEXT_BACK_BUTTON = English.JobPostings?.TEXT_BACK_BUTTON || "Back",
    TEXT_POST_A_JOB = English.JobPostings?.TEXT_POST_A_JOB || "Post a job",
    TEXT_MY_POSTING_BTN = English.JobPostings?.TEXT_MY_POSTING_BTN || "My Postings",
    TEXT_INACTIVE = English.JobPostings?.TEXT_INACTIVE || "Inactive",
    TEXT_ACTIVE = English.JobPostings?.TEXT_ACTIVE || "Active",
    TEXT_NO_JOB_POSTS = English.JobPostings?.TEXT_NO_JOB_POSTS || "No job posts available"
  } = LanguageData || {};

  useEffect(() => {
    setPageNumber(1);
    fetchMyJobPostings(1);
  }, []);

  const fetchMyJobPostings = async (page) => {
    page == 1 && setIsLoading(true);
    try {
      const payload = {
        UserId: loginData?.userInformation?.UserId,
        PageNumber: page,
        PageSize: 20,
        SearchString: "",
        Types: "",
        Trades: "",
        Location: "",
        Latitude: null,
        Longitude: null,
        RadiusKm: 0
      };
      const response = await Postrequestcall(FETCH_MY_JOBPOSTING, payload, loginData?.accessToken);

      if (response.status == 200 || response.data.status) {
        let resposeData = response?.data?.data || [];
        let totalCount = response?.data?.totalRecords || 0;
        let updatedJobPosts = page == 1 ? resposeData : [...myJobPost, ...resposeData];
        setMyJobPost(updatedJobPosts || []);
        setHasMoreData(updatedJobPosts.length < totalCount);
      }
    } catch (error) {
      console.error("Error fetching my job postings:", error);
    } finally {
      setIsLoading(false);
      setIsNextDataCalled(false);
    }
  };

  const handleJobItemClick = (event, item) => {
    setSelectedJobDetails(item);
    setShowJobDetailsModal(true);
  };

  const handleLoadMore = async () => {
    if (hasMoreData && !isNextDataCalled) {
      setIsNextDataCalled(true);
      const nextPage = pageNumber + 1;
      setPageNumber(nextPage);
      fetchMyJobPostings(nextPage);
    }
  };

  const renderJobList = (itemList) => {
    return itemList.map((item, index) => (
      <Card
        key={index.toString()}
        className="pagelist-content"
        sx={{
          marginTop: "0px",
          padding: 0,
          cursor: "pointer",
          backgroundColor: item?.applied ? "#f0f0f0" : "white"
        }}>
        <ListItem alignItems="flex-start" sx={{ m: 0, p: 0 }} key={index.toString()}>
          <ListItemButton
            alignItems="flex-start"
            sx={{ m: 0 }}
            onClick={(event) => handleJobItemClick(event, item)}>
            <ListItemText
              sx={{ mt: 0, alignItems: "flex-start" }}
              primary={
                <Stack
                  spacing={1}
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}>
                  <Typography variant="h6" maxWidth={"430px"} noWrap>
                    {item?.title}
                  </Typography>
                  <Typography variant="body2" maxWidth={"430px"} noWrap sx={{ color: BIGrey }}>
                    {moment(item?.jobPostedDate).format("MMMM DD, YYYY")}
                  </Typography>
                </Stack>
              }
              secondary={
                <Box>
                  <Stack
                    direction={"row"}
                    spacing={2}
                    alignItems={"flex-start"}
                    justifyContent={"space-between"}>
                    <Stack>
                      {item?.companyName && (
                        <Typography
                          variant="body2"
                          maxWidth={"430px"}
                          noWrap
                          sx={{ color: "black" }}>
                          {item?.companyName}
                        </Typography>
                      )}

                      {item?.location && (
                        <Typography
                          variant="body2"
                          maxWidth={"430px"}
                          noWrap
                          sx={{ color: BIGrey }}>
                          {item?.location}
                        </Typography>
                      )}

                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        flexWrap={"wrap"}
                        gap={1}
                        sx={{ mt: 0.5 }}>
                        {[...item?.jobPostTypes, ...(item?.trades?.slice(0, 5) || [])]?.map(
                          (tag, i) => (
                            <Chip label={tag?.typeName || tag?.tradeName || ""} key={i} />
                          )
                        )}
                        {item?.trades?.length > 5 && (
                          <Chip label={`+${item.trades.length - 5} more`} variant="outlined" />
                        )}
                      </Stack>
                    </Stack>
                    {item?.isExpired ? (
                      <Chip color="danger" variant="soft" label={TEXT_INACTIVE} />
                    ) : (
                      <Chip color="success" variant="soft" label={TEXT_ACTIVE} />
                    )}
                  </Stack>
                  <Divider sx={{ mt: 1 }} />
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    gap={10}
                    spacing={20}
                    sx={{ mt: 1 }}>
                    <Button
                      variant="text"
                      startIcon={<VisibilityIcon sx={{ color: BIGrey }} />}
                      sx={{ color: BIGrey }}>
                      {item?.viewCount || 0}
                    </Button>
                    <Button
                      variant="text"
                      startIcon={<SendIcon sx={{ color: BIGrey }} />}
                      sx={{ color: BIGrey }}>
                      {item?.appliedCount || 0}
                    </Button>
                  </Stack>
                </Box>
              }
            />
          </ListItemButton>
        </ListItem>
      </Card>
    ));
  };

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Pageheader headerName={TEXT_MY_POSTING_BTN} />

      <Card className="main-content-card">
        <Box flexDirection={"row"} sx={{ justifyContent: "space-between", display: "flex", mb: 2 }}>
          <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
            {TEXT_BACK_BUTTON}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setShowPostAJobModal(true);
            }}>
            <Add fontSize="small" /> {TEXT_POST_A_JOB}
          </Button>
        </Box>
        <Box className="main-content-card-list" id="scrollablediv_prodcut">
          {isLoading ? (
            <Loader />
          ) : myJobPost?.length > 0 ? (
            <InfiniteScroll
              dataLength={myJobPost?.length}
              next={handleLoadMore}
              hasMore={hasMoreData}
              loader={
                hasMoreData && (
                  <h4 style={{ display: "flex", justifyContent: "center" }}>
                    <Loader />
                  </h4>
                )
              }
              scrollableTarget="scrollablediv_prodcut">
              <List disablePadding>
                <Stack gap={1}>{renderJobList(myJobPost)}</Stack>
              </List>
            </InfiniteScroll>
          ) : (
            <Box className="empty-data-card">
              <Emptydata
                icon={
                  <img
                    src={JobPlaceHolder}
                    alt="JobPlaceHolder"
                    style={{ width: "500px", height: "400px", objectFit: "contain" }}
                  />
                }
                firstText={TEXT_NO_JOB_POSTS}
              />
            </Box>
          )}
        </Box>
      </Card>

      {showJobDetailsModal && (
        <ViewJobPosting
          loginData={loginData}
          open={showJobDetailsModal}
          onClose={() => setShowJobDetailsModal(false)}
          selectedJobDetails={selectedJobDetails || {}}
          from="myPostings"
          onJobDeleted={(postId) =>
            setMyJobPost(() => myJobPost.filter((job) => job.id !== postId))
          }
          onJobReposted={(updatedJob) =>
            setMyJobPost(() =>
              myJobPost.map((job) => (job.id === updatedJob.id ? updatedJob : job))
            )
          }
        />
      )}

      {showPostAJobModal && (
        <PostAJobModal
          open={showPostAJobModal}
          onClose={() => {
            setShowPostAJobModal(false);
          }}
          onNewJobPostedSuccess={() => {
            setPageNumber(1);
            fetchMyJobPostings(1);
          }}
        />
      )}
    </Box>
  );
}
